import { Stack, ButtonProps, ModalActions } from '@ui-components/neo.tax';

import { StyledActionText, StyledDoubleActionButton } from './connect-provider.styled';

export interface MultipleActionsProps {
  actions: {
    button: ButtonProps;
    actionText?: string;
  }[];
}

export const MultipleActions = ({ actions }: MultipleActionsProps): React.ReactElement => (
  <ModalActions hasTopBorder={false}>
    {actions.map((action) => (
      <Stack direction="column" alignItems="center" key={action.button.id}>
        <StyledDoubleActionButton {...action.button}>{action.button.children}</StyledDoubleActionButton>
        {action.actionText && (
          <StyledActionText as="p" fontSize="xs" fontWeight="medium" lineHeight={5}>
            {action.actionText}
          </StyledActionText>
        )}
      </Stack>
    ))}
  </ModalActions>
);
